import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'

type ContentViewerLoadingSpinnerProps = {
  size?: 'small' | 'large'
}

/**
 * Content Viewer Loading Spinner
 *
 * Displays a loading spinner for content viewer renderers.
 * Supports two sizes: small (for compact contexts) and large (for full viewer).
 * Uses centered layout for consistent UX across all content types.
 *
 * @param props - Spinner configuration
 * @param props.size - Spinner size ('small' or 'large', defaults to 'large')
 */
export default function ContentViewerLoadingSpinner({ size = 'large' }: ContentViewerLoadingSpinnerProps) {
  const spinnerSize = size === 'large' ? 30 : 12
  const containerClass = size === 'large' ? 'flex items-center justify-center h-full w-full' : 'p-4 flex justify-center items-center'

  return (
    <div className={containerClass}>
      <CircularProgressContinuousSized size={spinnerSize} thickness={7} />
    </div>
  )
}
